__turbopack_context__.v({
  "input": "mantineTextInput-module-scss-module__q5F0nG__input",
});
